
import { mapActions, mapGetters } from 'vuex';
import UIMentionCard from '@/components/ui/organism/UIMentionCard';
import { isDesktop } from '~/utils/screenSizes';
import { eventManager } from '@/utils/behavior/applicationEvents/event-manager';

export default {
  name: 'MentionCardWrapper',
  components: {
    UIMentionCard,
  },
  computed: {
    ...mapGetters('modals', [
      'currentMentionCard',
      'isMentionHovered',
      'isMentionCardHovered',
    ]),
    isDesktopSize() {
      return isDesktop();
    },
  },
  methods: {
    ...mapActions('modals', [
      'mouseEnterMentionCard',
      'mouseLeaveMentionCard',
      'followMentionCard',
    ]),
    handleShowMentionCard() {
      this.mouseEnterMentionCard();
    },
    handleHideMentionCard() {
      this.mouseLeaveMentionCard();
    },
    bindMentionCardEvent(node) {
      node.addEventListener('mouseenter', this.handleShowMentionCard);
      node.addEventListener('mouseleave', this.handleHideMentionCard);
    },
    removeMentionCardEvent(node) {
      node.removeEventListener('mouseenter', this.handleShowMentionCard);
      node.removeEventListener('mouseleave', this.handleHideMentionCard);
    },
    handleFollowMentionCard() {
      if (!this.currentMentionCard.profile.isFollowed) {
        if (this.currentMentionCard.profile.profileType == 'CompanyProfile') {
          eventManager.raiseFollowActiveEvent({
            active_name: this.currentMentionCard.profile.displayName,
            active_category: this.currentMentionCard.profile.companyType,
          });
        } else if (
          this.currentMentionCard.profile.profileType == 'PersonalProfile'
        ) {
          eventManager.raiseFollowInvestorEvent({
            investor_name: this.currentMentionCard.profile.profileName,
            investor_id: this.currentMentionCard.profile.profileId,
          });
        }
      }
      this.followMentionCard();
    },
  },
};
